// TODO check for custom event handler
export type CustomEventHandler<T> = (event: CustomEvent<T>) => void

export const eventBus = {
    on(event: string, callback: CustomEventHandler<any>) {
        document.addEventListener(event, (e: any) => callback(e.detail));
    },
    dispatch(event: string, data: any) {
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove(event: string, callback: EventListener) {
        document.removeEventListener(event, callback);
    },
};
